"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transportLayer = exports.productionLayer = exports.electricityLayer = exports.resourceNames = exports.resources = exports.allBuildings = exports.EventLog = exports.Board = exports.BoardManager = exports.GameEngine = void 0;
var GameEngine_1 = require("./GameEngine");
Object.defineProperty(exports, "GameEngine", { enumerable: true, get: function () { return GameEngine_1.GameEngine; } });
var BoardManager_1 = require("./BoardManager");
Object.defineProperty(exports, "BoardManager", { enumerable: true, get: function () { return BoardManager_1.BoardManager; } });
var Board_1 = require("./Board");
Object.defineProperty(exports, "Board", { enumerable: true, get: function () { return Board_1.Board; } });
var EventLog_1 = require("./EventLog");
Object.defineProperty(exports, "EventLog", { enumerable: true, get: function () { return EventLog_1.EventLog; } });
// Config
var buildings_1 = require("./config/buildings");
Object.defineProperty(exports, "allBuildings", { enumerable: true, get: function () { return buildings_1.allBuildings; } });
var resources_1 = require("./config/resources");
Object.defineProperty(exports, "resources", { enumerable: true, get: function () { return resources_1.resources; } });
Object.defineProperty(exports, "resourceNames", { enumerable: true, get: function () { return resources_1.resourceNames; } });
// Layers
var electricity_1 = require("./layers/electricity");
Object.defineProperty(exports, "electricityLayer", { enumerable: true, get: function () { return electricity_1.electricityLayer; } });
var production_1 = require("./layers/production");
Object.defineProperty(exports, "productionLayer", { enumerable: true, get: function () { return production_1.productionLayer; } });
var transport_1 = require("./layers/transport");
Object.defineProperty(exports, "transportLayer", { enumerable: true, get: function () { return transport_1.transportLayer; } });



//////////////////
// WEBPACK FOOTER
// ../engine/dist/index.js
// module id = LWbd
// module chunks = 0